import './layer-control-toggle.styl'

function LayerControlToggle({ style, setStyle }) {
  return (
    <div className={`layer-control-toggle layer-control-toggle--${style || 'Streets'}`}>
      <div
        className="layer-control-toggle__item z-depth-2"
        title={style === 'streets' ? 'Switch to satellite background' : 'Switch to streets background'}
        onClick={() => {
          setStyle(style === 'streets' ? 'satellite' : 'streets')
        }}
      />
    </div>
  )
}

export default LayerControlToggle
